module.exports = __webpack_public_path__ + "assets/0cc6f088e0d9eadfc080433d01f1f709.svg";